import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image } from 'components/core/Image';
import { Text } from 'components/core/Text';

export default function Tab({ className, logo, headline }) {
	return (
		<div className={classnames(className, 'tab')}>
			<Image src={logo} alt="logo" />
			<Text strong>{headline}</Text>
		</div>
	);
}

Tab.propTypes = {
	className: PropTypes.string,
	logo: PropTypes.string.isRequired,
	headline: PropTypes.string.isRequired
};
